/** Clear loaded Dashboard session state without importing its view. */
const clearers = new Set<() => void>();

export function registerUsageDashboardSessionCacheClear(clear: () => void): void {
  clearers.add(clear);
}

export function clearUsageDashboardProtectedSessionCaches(): void {
  for (const clear of Array.from(clearers)) clear();
}
